import z from "zod";

export const maintenanceWorkflowForwardingCancelSchema = z.object({
  cancel_reason: z.string().optional()
});

export type MaintenanceWorkflowForwardingCancelSchemaValidationSchema = z.infer<typeof maintenanceWorkflowForwardingCancelSchema>;